import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { ActionModel } from "../models/action";
import { FeatureCountries } from "../models/featureCountries";
import { DataDuplicateLanguage } from "../models/dataDuplicateLanguage";

@Injectable()
export class ActionService {
  /**
   * Load dependencies
   * @param {ApiService} apiService
   */
  constructor(private apiService: ApiService) {}

  /**
   * Fetch all actions from API
   * @returns {Observable<any>}
   */
  getAllActions() {
    return this.apiService.get("Action/GetAll").map((res) => {
      if (res && res.values) {
        return res.values.map((value) => new ActionModel(value));
      }
    });
  }

  /**
   * Fetch all feature countries from API
   * @returns {Observable<any>}
   */
  getAllFeatureLanguages() {
    return this.apiService.get("Action/GetAllFeatureLanguages").map((res) => {
      if (res && res.values) {
        return res.values.map((value) => new FeatureCountries(value));
      }
    });
  }

  /**
   * Get feature language status
   * @returns {Observable<any>}
   */
  getFeatureLanguageStatus(featureCode: string, languageId: number) {
    return this.apiService
      .get(
        "Action/FeatureLanguageStatus?featureCode=" +
          featureCode +
          "&languageId=" +
          languageId
      )
      .map((res) => {
        if (res && res.value) {
          return res.value;
        }
      });
  }

  // change feature availability
  changeFeatureAvailability(languageId: number, featureId: number) {
    return this.apiService.get(
      "Action/ChangeFeatureAvailability?languageId=" +
        languageId +
        "&featureId=" +
        featureId
    );
  }

  getDataDuplicateLanguage() {
    return this.apiService.get("Action/GetDataDuplicateLanguage").map((res) => {
      if (res && res.value) {
        return res.value;
      }
    });
  }

  saveDataDuplicateLanguage(dataDuplicateLanguage: DataDuplicateLanguage) {
    return this.apiService
      .post("Action/SaveDataDuplicateLanguage", dataDuplicateLanguage)
      .map((res) => {
        if (res && res.value) {
          return res.value;
        }
      });
  }

  // get header message
  getHeaderMessage() {
    return this.apiService.get("Action/GetHeaderMessage");
  }
}



// WEBPACK FOOTER //
// ./src/app/services/action.service.ts